import type { ReactNode } from "react";
import { PostHogProvider } from "@posthog/react";
import { getAnalyticsClient, initAnalytics } from "./analytics-client";

export const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  const enabled = initAnalytics();

  if (!enabled) {
    return <>{children}</>;
  }

  return <PostHogProvider client={getAnalyticsClient()}>{children}</PostHogProvider>;
};
